import React, { useState, useEffect } from 'react';
import './FilterModal.css';
import { IoMdCloseCircle } from 'react-icons/io';
import { BsCalendar3 } from 'react-icons/bs';

const InvoiceFilterModal = ({ isOpen, onClose, onApplyFilters, onClearFilters, initialFilters }) => {
  const [filters, setFilters] = useState({ startDate: '', endDate: '' });
  const [expandedDate, setExpandedDate] = useState(false);
  const [dateError, setDateError] = useState('');

  useEffect(() => {
    if (isOpen && initialFilters) {
      setFilters(initialFilters);
      setDateError('');
      setExpandedDate(!!(initialFilters.startDate || initialFilters.endDate));
    }
  }, [initialFilters, isOpen]);

  const hasActiveFilters = filters.startDate || filters.endDate;

  const today = new Date().toISOString().split('T')[0];

  const handleStartDate = (e) => {
    const val = e.target.value;
    setFilters(prev => ({ ...prev, startDate: val }));
    setDateError(filters.endDate && val >= filters.endDate ? 'From date must be before To date.' : '');
  };

  const handleEndDate = (e) => {
    const val = e.target.value;
    setFilters(prev => ({ ...prev, endDate: val }));
    setDateError(filters.startDate && val <= filters.startDate ? 'To date must be after From date.' : '');
  };

  const handleClearAll = () => {
    setFilters({ startDate: '', endDate: '' });
    setDateError('');
    setExpandedDate(false);
    onClearFilters();
    onClose();
  };

  const handleApply = () => {
    if (dateError) return;
    onApplyFilters(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div className="filter-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="filter-modal-header">
          <h2 className="filter-modal-title">Filters</h2>
          <div className="filter-modal-actions">
            <button className="filter-clear-button" onClick={handleClearAll} disabled={!hasActiveFilters}>
              Clear Filter
            </button>
            <button className="filter-apply-button" onClick={handleApply} disabled={!!dateError}>
              Apply Filter
            </button>
          </div>
          <IoMdCloseCircle onClick={onClose} size={18} color="brown" className="drawer_close_icon" />
        </div>

        <div className="filter-modal-content">
          <div className="filter-accordion">
            <div className="filter-accordion-header" onClick={() => setExpandedDate(v => !v)}>
              <span>Invoice Date</span>
              <span className="filter-accordion-icon">{expandedDate ? '−' : '+'}</span>
            </div>
            {expandedDate && (
              <div className="filter-accordion-content">
                <div className="filter-date-row">
                  <div className="filter-date-field">
                    <label>From</label>
                    <div className="filter-date-input-wrap">
                      <BsCalendar3 className="filter-date-icon" size={14} />
                      <input
                        type="date"
                        value={filters.startDate}
                        onChange={handleStartDate}
                        max={filters.endDate || today}
                        className="filter-date-input"
                      />
                    </div>
                  </div>
                  <div className="filter-date-field">
                    <label>To</label>
                    <div className="filter-date-input-wrap">
                      <BsCalendar3 className="filter-date-icon" size={14} />
                      <input
                        type="date"
                        value={filters.endDate}
                        onChange={handleEndDate}
                        min={filters.startDate || undefined}
                        max={today}
                        className="filter-date-input"
                      />
                    </div>
                  </div>
                </div>
                {dateError && <p className="filter-date-error">{dateError}</p>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFilterModal;
